export var PRECISION=1e3;
//# sourceMappingURL=constants.js.map